var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-small h-100 stats-small"},[_c('div',{staticClass:"card-header pb-0"},[_c('h6',{staticClass:"m-0 text-center"},[_vm._v("("+_vm._s(_vm.percentage)+") "+_vm._s(_vm.label))])]),_c('div',{staticClass:"card-body d-flex"},[_c('canvas',{ref:"drive",attrs:{"height":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }